/**
 * @file 订单失败态
 */
import styles from './index.module.scss';
import FailIcon from '@/assets/images/stake-fail.svg';
import { useFm } from '@web3/base-hooks';

interface Props {
  errorText: string;
  errorTitle?: string;
}

export const OrderResultFail = (props: Props) => {
  const { errorText, errorTitle } = props;
  const fm = useFm();

  return (
    <div className={styles.container}>
      <div className={styles.status}>
        <FailIcon className={styles.processIcon} />
        <div className={styles.title}>
          {errorTitle ? errorTitle : fm('failed')}
        </div>
        <div className={styles.desc}>{errorText}</div>
      </div>
      <div className={styles.content}></div>
    </div>
  );
};
